/**
 * Shared URL prefixes used by routes.js, layout (Root/Sidebar), and nav.
 * Keeps path strings in one place; routes.js re-exports these for existing imports.
 * For paths required before routes.js loads, see bootstrap-paths.js (home/CM only).
 */
import {INBOX_SERVICE_TYPES} from '@/config';

// Top-level app sections (match route `path` values in routes.js).
export const MENTAL_HEALTH_PREFIX = '/mental-health';
export const YOUR_CASES_PREFIX = '/your-cases';
export const ACCOUNT_PREFIX = '/account';
export const HEALTH_INFO_PREFIX = '/health-info';
export const MESSAGES_PREFIX = '/messages';
export const NOT_FOUND = '/not-found';
export const VIDEO_PREFIX = '/video';

export const MESSAGE_CENTER_PATH = '/message-center';

type InboxServiceType =
    (typeof INBOX_SERVICE_TYPES)[keyof typeof INBOX_SERVICE_TYPES];

// Inbox deep links by program; keys align with INBOX_SERVICE_TYPES in config.
export const INBOX_ROUTES: Record<InboxServiceType, string> = {
    [INBOX_SERVICE_TYPES.CareTeam]: `${MESSAGE_CENTER_PATH}/telemed`,
    [INBOX_SERVICE_TYPES.ChronicCare]: `${MESSAGE_CENTER_PATH}/chronic_care`,
    [INBOX_SERVICE_TYPES.MentalHealth]: `${MESSAGE_CENTER_PATH}/mental-health`,
};
